var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { typography as SStypography, space } from "styled-system";
import { typography, COLOR as colorVar } from "../../theme/constants";
export var TypographyWrapper = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n"], ["\n  color: ", ";\n\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n"])), function (_a) {
  var _b = _a.color,
      color = _b === void 0 ? "black" : _b;
  return colorVar[color];
}, function (_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? "body" : _b;
  var typo = typography[variant];
  return "\n      font-family: " + typo.fontFamily + ";\n      font-size: " + typo.fontSize + ";\n      font-weight: " + typo.fontWeight + ";\n      line-height: " + typo.lineHeight + ";\n    ";
}, function (_a) {
  var isUpperCase = _a.isUpperCase;
  return isUpperCase && "text-transform: uppercase;";
}, SStypography, space);
var templateObject_1;